import processHtmlAttributes from "../../common/html-attributes"

static var ignoredAttributes = [
    "class",
    "style",
    "type",
    "text",
    "icon",
    "a11yText",
    "noToggleIcon",
    "expanded",
    "reverse",
    "fixWidth",
    "borderless",
    "size",
    "priority",
    "iconTag",
    "disabled",
    "variant",
    "items",
    "label",
    "textAlign",
    "prefixLabel",
    "prefixId",
    "collapseOnSelect"
];

$ var isOverflowVariant = input.variant === "overflow";
$ var labelId = input.prefixId && component.getElId("label");

<span
    ...processHtmlAttributes(input, ignoredAttributes)
    class=["menu-button", input.class]
    style=input.style
    onExpander-expand("handleExpand")
    onExpander-collapse("handleCollapse")
    onMousedown("handleMousedown")>
        <ebay-button
        class=[
            `menu-button__button`,
            input.borderless && !isOverflowVariant && "expand-btn--borderless"
        ]
        variant=(isOverflowVariant ? "icon" : "expand")
        size=input.size
        priority=(input.priority || "none")
        icon-only=(!input.text && !input.icon && !isOverflowVariant)
        aria-expanded="false"
        aria-haspopup="true"
        aria-label=input.a11yText
        aria-labelledby=(labelId && `${input.prefixId} ${labelId}`)
        disabled=input.disabled
        on-escape("handleButtonEscape")
        key="button">
        <if(isOverflowVariant)>
            <ebay-overflow-icon/>
        </if>
        <else>
            <span class=[
                "expand-btn__cell",
                input.label && "menu-button__control--custom-label",
                input.textAlign === 'center' && "expand-btn__cell--center"
            ]>
                <if(input.label)>
                    <if(input.prefixLabel)>
                        <span class="menu-button-prefix-label">${input.prefixLabel}</span>
                        <${input.label.renderBody}/>
                    </if>
                    <else >
                        <span id=labelId>
                            <${input.label.renderBody}/>
                        </span>
                    </else>
                </if>
                <else>
                    <!-- TODO Cleanup -->
                    <!-- Convoluted markup to satisfy both Skin and Marko -->
                    <if(input.icon)>
                        <div no-update-body class="btn__icon">
                            <${input.icon}/>
                        </div>
                    </if>
                    <if(input.text)>
                        <span id=labelId>${input.text}</span>
                    </if>
                </else>
                <if(!input.noToggleIcon)>
                    <ebay-dropdown-icon/>
                </if>
            </span>
        </else>
    </ebay-button>
    <ebay-menu
        class-prefix="menu-button"
        type=input.type
        reverse=(isOverflowVariant ? !input.reverse : input.reverse)
        fix-width=input.fixWidth
        tabindex=-1
        on-keydown("handleMenuKeydown")
        on-change("handleMenuChange")
        on-select("handleMenuSelect")
        key="content">
        <for|item,index| of=input.items>
            <@item  ...item checked=component.isChecked(index) />
        </for>
    </ebay-menu>
</span>
